import { FC } from 'react';
import classNames from 'classnames';
import { default as NibllLogo } from '../../assets/nibll-logo.svg';

export interface LogoProps {
  className?: string;
}

export const Logo: FC<LogoProps> = ({ className }) => (
  <NibllLogo className={classNames('w-[88px] h-[24px] sm:w-[126px] sm:h-[32px]', className)} />
);
